module.exports = __webpack_public_path__ + "static/media/Search.900dd6e3.svg";